import * as React from "react";
import { Tabs } from "antd";
import _ from "lodash";
import { PositionProperty } from "csstype";
import { getSearchVal } from "utils/tool";
const TabPane = Tabs.TabPane;

interface ITabEnhanceProps {
  tabPanes: any;
  tabClickCallBack: any;
  // 占位组件
  slot?: any;
  // 时间戳
  timestamp?: any;
}

// tab组件增强
class TabEnhance extends React.Component<ITabEnhanceProps, any> {
  // state = {
  //   activeKey: ""
  // };
  constructor(props: ITabEnhanceProps) {
    super(props);
  }

  shouldComponentUpdate(nextProps: any, nextState: any, nextContext: any) {
    // console.log("new更新tab栏", nextProps.timestamp);
    const keys = Object.keys(
      this.difference(nextProps.tabPanes, this.props.tabPanes)
    );
    // console.log("keys", keys);
    if (keys.length > 0) {
      // console.log("new更新tab栏", nextProps.tabPanes);
      return true;
    }

    if (this.props.timestamp != nextProps.timestamp) {
      return true;
    }

    // if (nextProps.timestamp != this.props.timestamp) {
    //   console.log("tab_timestamp", "两次时间戳不相等");
    //   console.log("tab_timestamp", nextProps.timestamp, this.props.timestamp);
    //   return true;
    // } else return false;

    return false;
  }

  tabStyle = {
    position: "relative" as PositionProperty
  };

  // 比较两个对象的值是否相等 object:新值 base:旧值
  difference(object, base) {
    function changes(object, base) {
      return _.transform(object, function (result, value, key) {
        if (!_.isEqual(value, base[key])) {
          result[key] =
            _.isObject(value) && _.isObject(base[key])
              ? changes(value, base[key])
              : value;
        }
      });
    }
    return changes(object, base);
  }



  // componentDidUpdate(prevProps, prevState) {
  //   // async function show() {
  //   //   for (let i = 0; i < 10000; i++) {
  //   //     console.log(i);
  //   //   }
  //   // }
  //   // if (
  //   //   this.state &&
  //   //   prevState &&
  //   //   this.state.activeKey != prevState.activeKey
  //   // ) {
  //   //   this.props.tabClickCallBack(this.state.activeKey);
  //   // }
  //   //prevProps.tabClickCallBack(this.state.activeKey);
  //   //console.log("activeKey555", this.state.activeKey);
  //   // if (prevState && prevState.activeKey)
  //   //   this.props.tabClickCallBack(prevState.activeKey);
  // }


  callback = activeKey => {
    this.setState({
      activeKey
    });
    this.props.tabClickCallBack(activeKey);
  };

  getTabPane = () => {
    console.log("this.props.tabPanes", this.props.tabPanes);
    let tabs: any = [];
    this.props.tabPanes.map(item => {
      tabs.push(
        <TabPane tab={item.name} forceRender={false} key={item.value} />
      );
    });
    return tabs;
  };

  getDefaultActiveKey() {
    const orderstatus = getSearchVal(window.location.search, "orderstatus")
    const results = this.props.tabPanes.filter((item: any) => {
      return item.value * 1 === orderstatus as any * 1
    })

    return results.length > 0 ? results[0].value : 1
  }

  render() {
    const defaultActiveKey = this.getDefaultActiveKey() + ""
    const tabs = this.getTabPane();
    return (
      <div style={this.tabStyle}>
        {this.props.slot || []}
        <Tabs
          defaultActiveKey={defaultActiveKey}
          onChange={this.callback}
          animated={false}
          type="card"
        >
          {tabs}
        </Tabs>
      </div>
    );
  }
}

export default TabEnhance;
